export enum HealthRating {
    UNKNOWN = "UNKNOWN",
    HEALTHY = "HEALTHY",
    WARNING = "WARNING",
    SEVERE = "SEVERE"
}